<script>
import { useRouter, useRoute } from "vue-router";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import MenuCategory from "./MenuCategory.vue";
import CarouselTopbar from "./CarouselTopbar.vue";

export default {
	components: {
		MenuCategory,
		CarouselTopbar,
	},
	setup() {
		const store = useStore();
		const menu = computed(() => Object.entries(store.getters.menu));
		const router = useRouter();
		const route = useRoute();

		onMounted(() => {
			store.dispatch("getMenu");
		});

		const irAlHome = () => {
			router.push({ name: "Home" });
		};

		return {
			store,
			menu,
			route,
			router,
			irAlHome,
		};
	},
	data() {
		return {
			isMobileNavOpen: false, // Estado para rastrear el estado del menú
		};
	},
	methods: {
		MiPOA() {
			this.router.push({ name: "MiPOA" });
		},
		toggleMenu() {
			this.isMobileNavOpen = !this.isMobileNavOpen;
		},
	},
	watch: {
		isMobileNavOpen(newVal) {
			const headerElement = document.querySelector(".header");

			if (newVal)
				headerElement.classList.add("nav-open"); 
			else
				headerElement.classList.remove("nav-open");
		},
	},
};
</script>

<template>
	<header class="header">

		<div class="isologo" @click="irAlHome">
			<img class="isologotype" src="../../public/images/log17-200x110.png"/>
		</div>
		
		<nav class="nav-menu">

			<MenuCategory
				v-for="category in menu"
				:key="category[0]"
				:category="category[1]"
			/>
			<!-- Si es mobile chico -> dentro del hamburguesa -->
			<a
				class="mobile-torneos-menu"
				target="_blank"
				href="https://torneos.clubpoa.com.ar/login"
			>
				Inscripciones a Torneos
			</a>
				<div class="styled-icons icon-dark icon-circled icon-theme-colored icon-sm pull-right flip sm-pull-none sm-text-center social-media" style="gap: 0;">
					
					<!-- //* sacar display:none cuando Eugenia autorice (style="display: none") // Pasó despues de un año, lol -->
					<!-- Desktop -->
					<a
						class="social-action desktop-torneos"
						target="_blank"
						href="https://torneos.clubpoa.com.ar/login"
					>
						Inscripciones a Torneos
					</a>
					<a href="https://web.facebook.com/people/POA-Club-Argentino-de-Criadores-del-Perro-Ovejero-Alem%C3%A1n/100068426351096/" target="_blank">
						<i class="fa fa-facebook text-white"></i>
					</a>
					<a href="https://www.instagram.com/club_poa/" target="_blank">
						<i class="fa fa-instagram text-white"></i>
					</a>
				</div>
		</nav>

		<a class="royalcanin" href="https://www.royalcanin.com/ar" target="_blank">
			<img src="../../public/images/Royal_Canin.png"/>
		</a>

		<!-- Tablet / portrait ancho -->
		<a
			class="social-action mobile-torneos-header"
			target="_blank"
			href="https://torneos.clubpoa.com.ar/login"
		>
			Inscripciones a Torneos
		</a>

		<a class="menu-bar" @click="toggleMenu">
			<i class="fa fa-bars"></i>
		</a>

	</header>
</template>

<style scoped>
.header {
	height: 7rem;
	width: 100%;

	padding: 0 2rem;

	position: relative;
	z-index: 100;

	display: flex;
	gap: .5rem;
	flex-direction: row;
	align-items: center;

	list-style: none;
	
	background: white;
	box-shadow: 0 14px 28px rgba(0,0,0,0.15), 0 10px 10px rgba(0,0,0,0.22);
}

.header > .isologo,
.header > .royalcanin,
.header > .mobile-torneos-header,
.header > .menu-bar {
    flex-shrink: 0;
}

.header .icon-sm a {
	height: 35px !important;
	width: 35px !important;
	aspect-ratio: 1 !important;
	
	font-size: 20px !important;
	line-height: 1.75 !important;
}

.header .isologo {
	width: auto;

	display: flex;
	flex-direction: row;

	cursor: pointer;
}

.header .isologo > img {
	padding: 5px;
}

.header .royalcanin > img {
	height: 125px;
	max-width: unset !important;
	padding: 0;
}

.header > .isologo > p {
	margin-top: 7.5px;

	font-size: 15px;
	font-weight: 600;
	line-height: 1.25;
	text-transform: uppercase;
}

.header > .nav-menu {
	width: 100%;

	margin-left: auto;
	
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
}

.header .social-media {
	height: 100%;
	width: min-content;

	margin-left: auto;
	/* margin-right: 1.5rem; */

	display: flex;
	flex-direction: row;
	gap: .5rem;
}

.header.nav-open .social-media {
	display: none;
	visibility: hidden;

	position: absolute;
	top: 0;
	left: 0;
	z-index: -99;
}

.header .social-media > .iconos-topbar {
	margin: 0 5px;
}

.header .social-action {
	height: 36px;
	min-width: 120px;

	padding: 0 .9rem;
	margin-right: 1.2rem;

	display: inline-flex;
	align-items: center;
	justify-content: center;
	white-space: nowrap;

	color: #fff;
	font-size: .9rem;
	font-weight: 600;
	line-height: 1.1;
	text-decoration: none;

	border-radius: 15px;
	border: 1px solid #2f73b8;
	background: #2f73b8;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);

	transition: background-color .2s ease, transform .2s ease, box-shadow .2s ease;
}

/* Override icon-sm defaults so the Torneos button keeps rectangular shape and font size */
.header .social-media.icon-sm a.social-action {
	width: auto !important;
	height: 36px !important;
	min-width: 120px !important;
	padding: 0 .9rem !important;
	aspect-ratio: unset !important;
	border-radius: 4px !important;
	border: 1px solid #2f73b8 !important;
	background: #2f73b8 !important;
	font-size: .9rem !important;
	line-height: 1.1 !important;
}

.header .social-action:hover {
	background: #265d94;
	border-color: #265d94;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
	transform: translateY(-1px);
}

.header .social-action:active {
	transform: translateY(0);
}

.header > .menu-bar {
	display: none;
	visibility: hidden;

	position: absolute;
	top: 0;
	left: 0;
	z-index: -99;
}

/* Botón desktop */
.header .social-media.icon-sm a.desktop-torneos {
	min-width: 170px !important;
}

/* Por defecto no mostramos las variantes mobile */
.header .mobile-torneos-header,
.header .mobile-torneos-menu {
    display: none;
}

@media (orientation: portrait) {
	.header > .menu-bar {
		margin-left: auto;
		
		position: static;
		z-index: 0;

		display: block;

		color: #396fa5;
		font-size: 2.5rem;

		visibility: visible;
	}
	
	.header .royalcanin > img {
		height: 8rem;
	}

	.header > .isologo > img {
		height: 75px;
	}

	.header > .isologo > p {
		margin-top: 11px;

		font-size: .9rem;
	}

	.header > .nav-menu {
		display: none;
		visibility: hidden;
	}

	.header.nav-open > .nav-menu {
		position: absolute;
		top: 7rem;
		left: 0;
		z-index: 1;

		display: flex;
		flex-direction: column;

		background: white;

		visibility: visible;
	}

	.header.nav-open > .nav-menu > li {
		width: 100%;
	}

	.header .desktop-torneos {
        display: none !important;
    }

    @media (min-width: 641px) {

        .header .mobile-torneos-header {
            height: 34px;
            min-width: unset;

            margin-left: 1rem;
            margin-right: 1rem;
            padding: 0 .75rem;

            display: inline-flex;
            align-items: center;
            justify-content: center;

            font-size: .75rem;
            white-space: nowrap;	
			border-radius: 4px;
        }
    }

    @media (max-width: 640px) {

        .header .mobile-torneos-header {
            display: none;
        }

        .header.nav-open .mobile-torneos-menu {
            width: calc(100% - 40px);

            margin: 12px 20px 8px;
            padding: 11px 14px;

            display: block;

            color: #fff;
            font-size: 14px;
            font-weight: 700;
            text-align: center;
            text-decoration: none;

            background: #2f73b8;
            border-radius: 4px;
        }
    }
}
</style>
